'use client';

import { Entry } from '@/lib/parsers/entries';
import ListItem from '../AreaList/AreaList.ListItem';
import Flex from '../ui/Flex';

type RelevantAreasProps = {
  entries?: Partial<Entry>[];
};

const RelevantArea = ({ entries }: Partial<RelevantAreasProps>) => {
  return (
    <Flex rowGap="3xs" alignItems="start" as="ul" style={{ listStyle: 'none' }}>
      {entries?.map(
        (item) =>
          item && (
            <ListItem
              key={item.id}
              item={item}
              cx={{ mR: 'none' }}
              IconProps={{ cx: { color: 'accent' } }}
            />
          )
      )}
    </Flex>
  );
};

export default RelevantArea;
